<script setup lang="ts">
import type { AppRadioButtonOption } from './AppRadioButtons.model';

interface AppCircularRadioButtonsProps {
  items: AppRadioButtonOption[];
  selectedItem: string;
}
const props = defineProps<AppCircularRadioButtonsProps>();

interface AppCircularRadioButtonsEmits {
  (event: 'toggle-selected', value: string): void;
}
const emit = defineEmits<AppCircularRadioButtonsEmits>();
</script>

<template>
  <div class="app-circular-radio-buttons">
    <button
      v-for="item in props.items"
      :key="item.id"
      :for="item.id"
      class="custom-radio"
      @click="emit('toggle-selected', item.id)"
    >
      {{ item.label }}
      <input
        :id="item.id"
        type="radio"
        name="option"
        :value="item.label"
        :checked="item.id === selectedItem"
      />
      <span class="checkmark" />
    </button>
  </div>
</template>

<style scoped lang="scss">
@import '../../styles/_fonts.scss';
@import '../../styles/_media';
.app-circular-radio-buttons {
  --dot-size: 22px;
  --shadow-size: 44px;
  display: flex;
  align-items: center;
  height: var(--shadow-size);
  .custom-radio {
    all: unset;
    position: relative;
    padding-left: calc(var(--dot-size) + var(--spacing-12));
    cursor: pointer;
    display: inline-block;
    @include font-label-l-light;
    &:not(:last-child) {
      margin-right: var(--spacing-12);
    }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      &:checked ~ .checkmark {
        background-color: var(--color-white);
        border: 2px solid var(--color-neutral-70);
        &::after {
          display: block;
        }
      }
    }
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: var(--dot-size);
      width: var(--dot-size);
      background-color: var(--color-white);
      border: 2px solid var(--color-neutral-50);
      border-radius: 50%;

      &::after {
        content: '';
        position: absolute;
        display: none;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: var(--spacing-12);
        height: var(--spacing-12);
        border-radius: 50%;
        background-color: var(--color-neutral-70);
      }
    }
  }
}
</style>
